<template>
  <IconTable :icon-heading-list="iconHeadingList"></IconTable>
</template>

<script lang="ts" setup>
import IconPencil from '~/assets/icons/event/pencil-stroke.svg?component'
import IconNote from '~/assets/icons/event/note-stroke.svg?component'
import type { EventDescription } from '~/composables/types/event'

const props = withDefaults(
  defineProps<{
    eventDetails: EventDescription | null
  }>(),
  {
    eventDetails: null,
  }
)
const { t } = useI18n()

const eventData = toRef(() => props.eventDetails)
const iconHeadingList = [
  [
    {
      iconComp: IconNote,
      label: t('product.show.boxDetails.locationHomeTitle'),
      description: t('product.show.boxDetails.locationHomeDescription'),
    },
  ],
  [
    {
      iconComp: IconPencil,
      label: t('product.show.boxDetails.summaryMoreDetails'),
      description: eventGetters.getLocationSummary(eventData.value),
    },
  ],
]
</script>
